// extracted by mini-css-extract-plugin
export var callCard = "_oy-0";
export var callMessageButton = "_oy-1";
export var helpIcon = "_oy-3";
export var helpIconContainer = "_oy-4";
export var verticalDivider = "_oy-2";